{
  "name": "@ns/cancel-subscription",
  "version": "1.1.0",
  "requiredPermission": "BILLING_MANAGE",
  "description": "Cancelling your nodeStream subscription",
  "inputs": {
    "subscriptionId": {
      "type": "string"
    }
  },
  "outcomes": {
    "complete": {}
  },
  "jobMetadata": [
    "JOB_STATUS"
  ]
}
